{
  "name": "untracked-ita-fe",
  "version": "Camembert-1.0.5",
  "scripts": {
    "ng": "ng",
    "start-local-mock": "ng serve --configuration=local-mock",
    "start-local-dev": "ng serve --configuration=local-development",
    "start-local-stage": "ng serve --configuration=stage",
    "build": "ng build",
    "build-dev": "ng build --configuration=development",
    "build-stage": "ng build --configuration=stage",
    "build-local-dev": "ng build --configuration=local-development",
    "build-prod": "ng build --configuration=production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test --watch=false",
    "test1": "ng test --no-watch --browsers=Chrome",
    "test-e2e": "./tests/run-e2e.sh",
    "start-e2e-live": "ng serve --configuration=local-development --proxy-config src/proxy-e2e-live.conf.js",
    "test-e2e-live:local": "E2E_API_URL=http://localhost:3000/api/v1 ./tests/run-e2e-live.sh",
    "test-e2e-live:stage": "E2E_API_URL=https://services.untracked-ita.com/api/v1 ./tests/run-e2e-live.sh",
    "serve:ssr:untracked-ita-fe": "node dist/untracked-ita-fe/server/server.mjs",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.2.0",
    "@angular/cdk": "^17.3.10",
    "@angular/common": "^17.2.0",
    "@angular/compiler": "^17.2.0",
    "@angular/core": "^17.2.0",
    "@angular/forms": "^17.2.0",
    "@angular/google-maps": "^17.3.10",
    "@angular/material": "^17.3.10",
    "@angular/material-moment-adapter": "^17.3.10",
    "@angular/platform-browser": "^17.2.0",
    "@angular/platform-browser-dynamic": "^17.2.0",
    "@angular/platform-server": "^17.2.0",
    "@angular/router": "^17.2.0",
    "@angular/ssr": "^17.2.2",
    "@ngrx/effects": "^17.2.0",
    "@ngrx/store": "^17.2.0",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@types/quill": "^2.0.14",
    "bootstrap": "^5.3.3",
    "express": "^4.18.2",
    "flag-icons": "^7.3.2",
    "moment": "^2.30.1",
    "ng2-currency-mask": "^13.0.3",
    "ngx-quill": "^25.3.3",
    "quill": "^2.0.3",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.2.2",
    "@angular/cli": "^17.2.2",
    "@angular/compiler-cli": "^17.2.0",
    "@ngrx/store-devtools": "^17.2.0",
    "@playwright/test": "^1.58.0",
    "@types/express": "^4.17.17",
    "@types/google.maps": "^3.58.1",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^18.18.0",
    "angular-eslint": "19.4.0",
    "eslint": "^9.26.0",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-html-reporter": "^0.2.7",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.3.2",
    "typescript-eslint": "8.32.0"
  }
}
